import type React from "react";

interface TemplatePreviewIconProps {
  className?: string;
  isSelected?: boolean;
}

export const TemplateTableIcon: React.FC<TemplatePreviewIconProps> = ({ className, isSelected }) => {
  // Selected: purple header (#7F56D9), purple bars (#9E77ED)
  // Unselected: gray header (#A4A7AE), gray bars (#D5D7DA)
  const colors = isSelected ? { headerBg: "#7F56D9", cellBar: "#9E77ED" } : { headerBg: "#A4A7AE", cellBar: "#D5D7DA" };

  return (
    <svg
      width="122"
      height="118"
      viewBox="0 0 105 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_table)">
        {/* Header Row */}
        <rect width="259.185" height="16" fill={colors.headerBg} />
        <path
          d="M6 8C6 6.89543 6.89543 6 8 6H52.3393C53.4439 6 54.3393 6.89543 54.3393 8C54.3393 9.10457 53.4439 10 52.3393 10H8C6.89543 10 6 9.10457 6 8Z"
          fill="white"
        />
        <path
          d="M58.3398 8C58.3398 6.89543 59.2353 6 60.3398 6H151.763C152.867 6 153.763 6.89543 153.763 8C153.763 9.10457 152.867 10 151.763 10H60.3398C59.2353 10 58.3398 9.10457 58.3398 8Z"
          fill="white"
        />

        {/* Row 1 */}
        <rect width="259.185" height="16" transform="translate(0 18)" fill="#FAFAFA" />
        <path
          opacity="0.3"
          d="M6 26C6 24.8954 6.89543 24 8 24H52.3393C53.4439 24 54.3393 24.8954 54.3393 26C54.3393 27.1046 53.4439 28 52.3393 28H8C6.89543 28 6 27.1046 6 26Z"
          fill={colors.cellBar}
        />
        <path
          opacity="0.3"
          d="M58.3398 26C58.3398 24.8954 59.2353 24 60.3398 24H151.763C152.867 24 153.763 24.8954 153.763 26C153.763 27.1046 152.867 28 151.763 28H60.3398C59.2353 28 58.3398 27.1046 58.3398 26Z"
          fill={colors.cellBar}
        />

        {/* Row 2 */}
        <rect width="259.185" height="16" transform="translate(0 36)" fill="#FAFAFA" />
        <path
          opacity="0.3"
          d="M6 44C6 42.8954 6.89543 42 8 42H52.3393C53.4439 42 54.3393 42.8954 54.3393 44C54.3393 45.1046 53.4439 46 52.3393 46H8C6.89543 46 6 45.1046 6 44Z"
          fill={colors.cellBar}
        />
        <path
          opacity="0.3"
          d="M58.3398 44C58.3398 42.8954 59.2353 42 60.3398 42H151.763C152.867 42 153.763 42.8954 153.763 44C153.763 45.1046 152.867 46 151.763 46H60.3398C59.2353 46 58.3398 45.1046 58.3398 44Z"
          fill={colors.cellBar}
        />

        {/* Row 3 */}
        <rect width="259.185" height="16" transform="translate(0 54)" fill="#FAFAFA" />
        <path
          opacity="0.3"
          d="M6 62C6 60.8954 6.89543 60 8 60H52.3393C53.4439 60 54.3393 60.8954 54.3393 62C54.3393 63.1046 53.4439 64 52.3393 64H8C6.89543 64 6 63.1046 6 62Z"
          fill={colors.cellBar}
        />
        <path
          opacity="0.3"
          d="M58.3398 62C58.3398 60.8954 59.2353 60 60.3398 60H151.763C152.867 60 153.763 60.8954 153.763 62C153.763 63.1046 152.867 64 151.763 64H60.3398C59.2353 64 58.3398 63.1046 58.3398 62Z"
          fill={colors.cellBar}
        />

        {/* Row 4 */}
        <rect width="259.185" height="16" transform="translate(0 72)" fill="#FAFAFA" />
        <path
          opacity="0.3"
          d="M6 80C6 78.8954 6.89543 78 8 78H52.3393C53.4439 78 54.3393 78.8954 54.3393 80C54.3393 81.1046 53.4439 82 52.3393 82H8C6.89543 82 6 81.1046 6 80Z"
          fill={colors.cellBar}
        />
        <path
          opacity="0.3"
          d="M58.3398 80C58.3398 78.8954 59.2353 78 60.3398 78H151.763C152.867 78 153.763 78.8954 153.763 80C153.763 81.1046 152.867 82 151.763 82H60.3398C59.2353 82 58.3398 81.1046 58.3398 80Z"
          fill={colors.cellBar}
        />

        {/* Row 5 */}
        <rect width="259.185" height="16" transform="translate(0 90)" fill="#FAFAFA" />
        <path
          opacity="0.3"
          d="M6 98C6 96.8954 6.89543 96 8 96H52.3393C53.4439 96 54.3393 96.8954 54.3393 98C54.3393 99.1046 53.4439 100 52.3393 100H8C6.89543 100 6 99.1046 6 98Z"
          fill={colors.cellBar}
        />
        <path
          opacity="0.3"
          d="M58.3398 98C58.3398 96.8954 59.2353 96 60.3398 96H151.763C152.867 96 153.763 96.8954 153.763 98C153.763 99.1046 152.867 100 151.763 100H60.3398C59.2353 100 58.3398 99.1046 58.3398 98Z"
          fill={colors.cellBar}
        />
      </g>
      <defs>
        <clipPath id="clip0_table">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0H253.185C256.499 0 259.185 2.68629 259.185 6V100C259.185 103.314 256.499 106 253.185 106H5.99999C2.68629 106 0 103.314 0 100V6Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
